export default __webpack_public_path__ + "static/media/vivo_one.64e6ce4e.webp";